<template>
  <div class="l-page l-page--step-result-detail">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <date-range-picker
          ref="refCalendarModal"
          :initial-start-date="calendarStartDate"
          :initial-end-date="calendarEndDate"
          :on-date-range-changed="onDateRangeChanged"
          cancel-button-label="キャンセル"
          enter-button-label="決定"
        />
      </div>

      <div class="l-main-content">
        <div class="p-step-result-detail">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">シナリオ配信成果</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ displayStartDate }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ displayEndDate }}</li>
              </ul>
            </div>
          </h2>
          <analysis-tab
            classes="c-tab--step-message"
            :current="tab.current"
            :on-select="onTabClick"
          />
          <!-- <div class="p-step-result-detail__graph is-empty"> -->
          <div class="p-step-result-detail__graph p-step-result-detail__graph--scrollable"  :class="[{'is-loading': isLoadingGraph}, {'is-empty': isEmpty}]">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-step-metrics-list" :style="{ minWidth: minGraphWidthPx }">
              <div v-for="n in stepCount" :key="'metrics-' + n" class="p-step-metrics-list__item">
                <div class="p-step-metrics__label">{{ n }}回目の配信</div>
                <div class="p-step-metrics__value">-</div>
              </div>
            </div>
            <svg class="c-graph-stack-chart c-graph-stack-chart--step-message" :style="{ width: minGraphWidthPx, minWidth: minGraphWidthPx }">
              <!-- クリッピングマスク: 背景フレームと同サイズ -->
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="20"
                    height="417"
                    width="930"
                  />
                </clipPath>
              </defs>

              <!-- 背景フレーム -->
              <g class="c-graph-stack-chart-frame" clip-path="url(#clipPathStackChart)">
                <rect
                  class="c-graph-stack-chart-frame__rect"
                  x="0"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-stack-chart-frame__line"
                  x1="0"
                  x2="930"
                  y1="331"
                  y2="331"
                />
              </g>

              <!-- Y軸罫線 -->
              <g class="c-graph-stack-chart-bg" clip-path="url(#clipPathStackChart)">
                <g class="c-graph-stack-chart-bg__x" />
              </g>

              <!-- 積み上げグラフバー -->
              <g class="c-graph-stack-chart-bar" clip-path="url(#clipPathStackChart)" />

              <!-- 積み上げグラフバー -->
              <g class="c-graph-stack-chart-bar-adapter" clip-path="url(#clipPathStackChart)" />

              <!-- 積み上げグラフバー用ラベル -->
              <g class="c-graph-stack-chart-bar-diff-label" />
            </svg>

            <div class="p-step-abandonment-list" :style="{ minWidth: minGraphWidthPx }">
              <div v-for="n in abandonmentCount" :key="'abandonment-' + n" class="p-step-abandonment-list__item">
                <div class="p-step-abandonment__icon">
                  <div class="c-icon-circle c-icon-circle--white u-wh40">
                    <div
                      class="c-icon-circle__item c-icon-circle__item--pink c-icon-circle__item--stroke-pink u-wh30"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#arrow-line-down" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="p-step-abandonment__label">離脱</div>
                <div class="p-step-abandonment__value">-</div>
              </div>
            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-text"><a :href="stepCsvUrl">CSVデータ ダウンロード</a></div>
          </h3>
          <div class="p-step-result-detail__data" :class="[{'is-loading': isLoadingDataTable}, {'is-empty': isEmpty}]">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--stack-chart-step-message">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w80 is-sortable">
                    <span class="c-table__text">ステップ</span>
                    <sort-switch name="step" :order="sortTargets.step" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w240 is-sortable">
                    <span class="c-table__text">タイトルメッセージ</span>
                    <sort-switch name="title" :order="sortTargets.title" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="send_start_date" :order="sortTargets.send_start_date" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w140">
                    <span class="c-table__text">配信トリガー</span>
                  </th>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <sort-switch name="impression" :order="sortTargets.impression" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <sort-switch name="click" :order="sortTargets.click" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">クリック率(%)</span>
                    <sort-switch name="ctr" :order="sortTargets.ctr" @on-click="onSortButtonClick($event)" />
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    displayPeriod: Object,
    scenarioId: String,
  },
  data () {
    return {
      errorMessage: '',
      graphModule: null,
      tableModule: null,
      isEmpty: false,
      isError: false,
      isLoadingGraph: true,
      isLoadingDataTable: true,
      // 初期表示は from/to を未指定にして API 側に自動算出させる（要望⑤）。
      // 配信期間（最初の配信日〜最終配信日、当日含む）がレスポンスから返ってきたら UI に反映する。
      // 親側から displayPeriod が明示されている場合のみそれを使う。
      range: {
        from: this.displayPeriod && this.displayPeriod.from && dayjs(this.displayPeriod.from).isValid()
          ? dayjs(this.displayPeriod.from).toDate()
          : null,
        to: this.displayPeriod && this.displayPeriod.to && dayjs(this.displayPeriod.to).isValid()
          ? dayjs(this.displayPeriod.to).toDate()
          : null,
      },
      isDateRangeManual: !!(this.displayPeriod && this.displayPeriod.from && this.displayPeriod.to),
      // DateRangePicker は mounted で props の初期値を親に通知するため
      // onDateRangeChanged が必ず 1 回発火する。これを「ユーザー手動指定」と
      // 誤認すると isDateRangeManual=true が立ってしまい、API 自動算出の
      // 「最初の配信日〜最終配信日」反映（要望⑤）が無効化される。
      // 初回コールバックを区別するためのガードフラグ。
      isPickerInitialized: false,
      tab: {
        current: 'delivery',
      },
      sort: {
        key: 'delivery',
        type: 'desc'
      },
      sortTargets: {
        stepId: 1,
        title: 0,
        send_start_date: 0,
        impression: 0,
        click: 0,
        ctr: 0,
      },
      // 上部メトリクスボックスと離脱ボックスを動的描画するための items 数。
      // API レスポンスの items.length を反映し、6 ステップ以上のシナリオでも描画できるようにする。
      items: [],
    }
  },

  computed: {
    calendarStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY-MM-DD')
        : dayjs().add(-30, 'days').format('YYYY-MM-DD')
    },
    calendarEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    },
    displayStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY/MM/DD')
        : '-'
    },
    displayEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY/MM/DD')
        : '-'
    },
    stepCount: function () {
      // ステップ数（メトリクスボックスの数）。最低5を保証（empty 時のレイアウトを維持）。
      return Math.max(5, this.items ? this.items.length : 0);
    },
    abandonmentCount: function () {
      // 離脱ボックスは「最後のステップ以外」の数（Step1→Step2 ... Step(N-1)→StepN）。
      return Math.max(4, this.stepCount - 1);
    },
    minGraphWidthPx: function () {
      // 1 ステップあたり 186px (旧 930/5) で固定し、ステップ数だけ最小幅を確保する。
      // 親要素を overflow-x: auto にすると 6 ステップ以上は横スクロールで見られる。
      return (this.stepCount * 186) + 'px';
    },
    stepCsvUrl: function() {
      // range が未設定（要望⑤ の初期ロード前など）の場合は from/to をクエリに含めない。
      const params = ['scenario_id=' + this.scenarioId];
      if (this.range.from && dayjs(this.range.from).isValid()) {
        params.push('from=' + dayjs(this.range.from).format('YYYY-MM-DD'));
      }
      if (this.range.to && dayjs(this.range.to).isValid()) {
        params.push('to=' + dayjs(this.range.to).format('YYYY-MM-DD'));
      }
      return '/api/step/summary/csv?' + params.join('&');
    },

  },
  mounted: function() {
    import('../../funcs/pages/step-result-detail').then(module => {
      module.StepResultDetail();
    });
    import('../../funcs/components/graph/graph-stack-chart-delivery-step-message').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.graphModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    });

    import('../../funcs/components/table/table-delivery-step-message').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.tableModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    });
  },

  methods: {
    updateDataset: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.graphModule || !this.tableModule) return;

      // ローダー表示設定
      this.isLoadingGraph = true;
      this.isLoadingDataTable = true;

      // 送信パラメーター作成。
      // ユーザーが期間を明示していない場合は from/to を渡さず、API 側に自動算出させる（要望⑤）。
      const params = { scenario_id: this.scenarioId };
      if (this.range.from && this.range.to) {
        params.from = dayjs(this.range.from).format('YYYY-MM-DD');
        params.to = dayjs(this.range.to).format('YYYY-MM-DD');
      }

      // ヒートマップ用データの取得処理実行
      //axios.get(`/api/step/summary/${this.tab.current}`, {
      axios.get(`/api/step/summary`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // 自動算出された配信期間を UI に反映する（要望⑤）。
        // 既にユーザーが明示的に期間設定している場合は上書きしない。
        if (!this.isDateRangeManual && res.data.from && res.data.to) {
          const respFrom = dayjs(res.data.from);
          const respTo = dayjs(res.data.to);
          if (respFrom.isValid()) this.range.from = respFrom.toDate();
          if (respTo.isValid()) this.range.to = respTo.toDate();
        }

        // 上部メトリクス／離脱の DOM 数を items.length に合わせるため Vue 側 data に保存。
        // テンプレート側で v-for に使われるので Vue の nextTick 後にモジュール描画する必要がある。
        this.items = res.data.items || [];

        // 要望⑦: 未配信シナリオでは「配信後にデータが反映されます」を表示する。
        // 仕様: 「シナリオ内のメッセージが一つも配信済になっていない場合」が対象。
        // = items のうち配信実績 (delivery > 0) を持つメッセージが 1 件も存在しない。
        // items 自体が空のケースも未配信扱いとする。
        // 空状態 DOM はテンプレート側 (.c-empty) に既に用意されており、is-empty
        // クラスの付与で表示が切り替わる。
        const hasAnyDeliveredMessage = this.items.some(
          (item) => (Number(item.delivery) || 0) > 0
        );
        this.isEmpty = this.items.length === 0 || !hasAnyDeliveredMessage;

        // シナリオ配信成果の更新: グラフ
        // DOM 反映を待ってからモジュールに描画させる
        this.$nextTick(() => {
          this.graphModule.graph(res.data);
          this.graphModule.metrics(res.data);
          this.graphModule.abandonment(res.data);
        });
        // シナリオ配信成果の更新: テーブル
        this.tableModule.init(res.data);
        this.tableModule.dataList({
          key: 'delivery',
          order: 'desc',
        });

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingGraph = false;
          this.isLoadingDataTable = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingGraph = false;
            this.isLoadingDataTable = false;
          }, 300)
        });
    },

    onTabClick: function(selected) {
      // 選択値が設定されていない場合は処理終了
      if (!selected) return;

      // 選択値が現在の選択値値と同じ場合は処理終了
      if (selected == this.tab.current) return

      // 選択値を現在のタブ名に設定
      this.tab.current = selected;

      // データ更新
      this.updateDataset();
    },

    onDateRangeChanged: function(range){
      // DateRangePicker の mounted 直後に発火する初回コールバックでは
      // 「ユーザーによる手動指定」と見なさない。これは props 初期値を親に
      // 通知するための仕組みであり、ここで isDateRangeManual=true を立てると
      // API レスポンスの自動算出期間（要望⑤）が反映されなくなる。
      // 2 回目以降（カレンダーモーダルの「決定」押下による発火）のみを
      // 手動指定と扱う。
      if (!this.isPickerInitialized) {
        this.isPickerInitialized = true;
        return;
      }

      // 取得データ期間の更新
      this.range.from = range.start;
      this.range.to= range.end;
      // ユーザーが手動で期間を指定したので、以降は API レスポンスの自動算出値で
      // 上書きしないようフラグを立てる（要望⑤）。
      this.isDateRangeManual = true;

      // データ更新
      this.updateDataset();
    },

    onSortButtonClick: function (target) {
      this.currentSortTarget = target;
      if (!this.sortTargets[target] || (this.sortTargets[target] == -1)) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }

      const sorts = {};
      if (this.sortTargets[target] > 0) {
        sorts.order = 'asc';
      } else {
        sorts.order = 'desc';
      }

      sorts.key = target;
      this.tableModule.dataList(sorts);

    },


    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>

<style scoped>
/*
 * 6 ステップ以上のシナリオでもメトリクス・離脱・グラフの各ボックスサイズを変えずに
 * 横スクロールで全件見られるようにする。
 * 5 ステップまでは現状の見た目と一致（min-width が 930px 以下になり overflow しない）。
 *
 * 既存 SCSS で .p-step-metrics-list { width: 100% }, .p-step-metrics-list__item { width: 186px },
 * .p-step-abandonment-list__item { width: 150px } などが定義されているので、
 * !important で確実に上書きしてレイアウトを揃える。
 */
.p-step-result-detail__graph--scrollable {
    overflow-x: auto;
}

/* メトリクスリスト・離脱リストは「子要素の合計幅」で決まるようにする (auto) */
.p-step-result-detail__graph--scrollable .p-step-metrics-list,
.p-step-result-detail__graph--scrollable .p-step-abandonment-list {
    width: auto !important;
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
}

/* メトリクス各ボックスは 186px 固定 (5 ボックスで合計 930px、6 以上は右にはみ出して overflow-x で見せる) */
.p-step-result-detail__graph--scrollable .p-step-metrics-list__item {
    flex: 0 0 186px !important;
    width: 186px !important;
}

/*
 * 離脱ボックスはメトリクスボックスの「境目」に配置するため、左右に半バー分 (186/2 = 93px)
 * の padding を取り、各離脱ボックスを 186px 幅で固定する。
 * 結果として総幅 = 93 + (stepCount - 1) * 186 + 93 = stepCount * 186 となり、
 * メトリクスリストと総幅が揃いつつ、各離脱はちょうど 2 つのメトリクスの中間に置かれる。
 */
.p-step-result-detail__graph--scrollable .p-step-abandonment-list {
    padding-left: 93px !important;
    padding-right: 93px !important;
    box-sizing: border-box;
}
.p-step-result-detail__graph--scrollable .p-step-abandonment-list__item {
    flex: 0 0 186px !important;
    width: 186px !important;
    /* 既存 SCSS の nth-child(1) ml 65 / nth-child(2-4) ml 35 を打ち消して、
       padding-left 93 と width 186 だけで band 境界 (= bar 対の中間) に揃える */
    margin-left: 0 !important;
}

.p-step-result-detail__graph--scrollable .c-graph-stack-chart--step-message {
    display: block;
}
</style>
